import React from 'react'
import { Tag } from 'antd'
import PropTypes from 'prop-types'
import styles from 'view/component/user-types/styles'

const Tags = ({ tags }) => {
  return (
    <div className={styles.tag_wrapper}>
      {tags.map((tags) => {
        return tags &&
          <Tag
            className={styles.tag}
            key={tags.uuid}
          >
            {tags.name}
          </Tag>
      })}
    </div>
  )
}

Tags.propTypes = {
  tags: PropTypes.array
}

export default Tags
